export default __webpack_public_path__ + "static/media/kyle.8d2d0bf0.png";